export default {
  bind (el, { value }) {
    if (value.active) {
      let autoplay = null
      const setAutoPlay = () => {
        autoplay = window.setInterval(() => {
          if (!document.hidden) {
            value.callback()
          }
        }, value.delay)
      }
      setAutoPlay()
      el.addEventListener('mouseenter', () => {
        window.clearInterval(autoplay)
      })
      el.addEventListener('mouseleave', setAutoPlay)
    }
  }
}
